import ResourceCrudPage, {
  Field,
  TextInput,
  TextArea,
  NumberInput,
} from "./ResourceCrudPage";

export default function AdminTestimonialsPage() {
  return (
    <ResourceCrudPage
      resource="testimonials"
      title="Testimonials"
      subtitle="Parent quotes shown on the homepage."
      testIdPrefix="testimonials"
      blank={() => ({
        name: "",
        quote: "",
        related_program: "",
        display_order: 100,
        active: true,
      })}
      validate={(f) =>
        !f.quote?.trim()
          ? { ok: false, message: "Quote is required." }
          : { ok: true }
      }
      renderRow={(item) => (
        <div>
          <p className="font-display font-bold text-slate-900 line-clamp-2">
            "{item.quote}"
          </p>
          <p className="text-xs text-slate-500 mt-1">
            {item.name || "Anonymous"}
            {item.related_program ? ` · ${item.related_program}` : ""}
          </p>
        </div>
      )}
      renderForm={({ form, setField }) => (
        <>
          <Field label="Parent / customer name (optional)">
            <TextInput value={form.name} onChange={setField("name")} />
          </Field>
          <Field label="Quote">
            <TextArea
              rows={4}
              value={form.quote}
              onChange={setField("quote")}
              data-testid="testimonials-form-quote"
            />
          </Field>
          <Field label="Related program (optional)">
            <TextInput
              value={form.related_program}
              onChange={setField("related_program")}
            />
          </Field>
          <Field label="Display order">
            <NumberInput
              value={form.display_order}
              onChange={setField("display_order")}
            />
          </Field>
          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={!!form.active}
              onChange={(e) => setField("active")(e.target.checked)}
            />
            Active (visible on public site)
          </label>
        </>
      )}
    />
  );
}
